
import { selectList, SYMBOL } from "@/collocate"
import BalanceCom from "@/components/BalanceCom"
import ButtonDefault from "@/components/ButtonDefault"
import ButtonPrimary from "@/components/ButtonPrimary"
import PresentData from "@/components/PresentData"
import ScrollView from "@/components/ScrollView"
import { StakeBill } from "@/interface"
import useFlowClaim from "@/web3Hook/useFlowClaim"
import useFlowWithdraw from "@/web3Hook/useFlowWithdraw"
import { Tooltip } from "antd"
import { formatUnits } from "ethers"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import dayjs from 'dayjs';
import useGetUserInfo from "@/web3Hook/useGetUserInfo"
import useGetStakeByLimit from "@/web3Hook/useGetStakeByLimit"
import usePendingStake from "@/web3Hook/usePendingStake"
import useGetStakes from "@/web3Hook/useGetStakes"
const leftClassName = " font-light text-a8 text-xs md:text-sm"
const rightClassName = " font-light text-white text-xs md:text-sm font-semibold"

const History = () => {
    const { t } = useTranslation();
    const { userInfo, userInfoLod, getUserInfo } = useGetUserInfo();

    // 获取订单
    const { getStakeByLimit, data, getStakeByLimitLod, end } = useGetStakeByLimit()
    return (
        <ScrollView className="bg-3c rounded-lg px-2.5 mx-2.5 md:mx-4" scroll={{ isOver: end, loading: getStakeByLimitLod, onScroll: getStakeByLimit }} px={"12.8125rem"}>
            <div className=" bg-21  text-ac text-center rounded-md  py-5 md:py-6 flex flex-col justify-between mt-5 mx-3.5">
                <span className="text-xs md:text-sm text-grayA8 pb-3">
                    {t('contract.currentTotalHashrate')}
                </span>
                <BalanceCom className="text-white text-base md:text-lg" balance={userInfo.poolBalance} loading={userInfoLod} text={SYMBOL} />
            </div>
            {data.map((item, index) => {
                return <div key={index}>
                    <HistoryItem getUserInfo={getUserInfo} item={item} />
                </div>
            })}
        </ScrollView>
    )
}



const HistoryItem = (props: { item: StakeBill, getUserInfo: Function }) => {
    const { t } = useTranslation()
    const { item, getUserInfo } = props
    // 真正使用的数据
    const [data, setData] = useState(item)
    const { pendingStakeData, pendingStakeLod, getPendingStake } = usePendingStake()
    // 单独获取数据
    const { stakesLod, getStakes } = useGetStakes()
    // 更新
    const update = () => {
        // 单独获取账单数据
        getStakes(data.id).then((res) => {
            setData(res)
        })
        // 获取账单未提取收益
        getPendingStake(data.id)
    }
    // 提取收益
    const { getFlowClaim, flowClaimLod } = useFlowClaim(1)
    // 赎回
    const { getFlowWithdraw, flowWithdrawLod } = useFlowWithdraw(1)

    const getFlowClaimFun = () => {
        getFlowClaim(data.id, {
            success: t('contract.claimSuccess'),
            error: t('contract.claimFailed'),
        },
            () => {
                update()
                getUserInfo()
            }
        )
    }
    const getFlowWithdrawFun = () => {
        getFlowWithdraw(data.id, {
            success: t('contract.redeemSuccess'),
            error: t('contract.redeemFailed'),
        },
            () => {
                update()
                getUserInfo()
            }
        )
    }

    useEffect(() => {
        getPendingStake(item.id)
    }, [getPendingStake, item.id])
    const unlockCycleDay = selectList.find(item => item.unlockCycle === Number(formatUnits(data.unlockCycle, 0)))?.value || '';

    return <div className="relative box-border pt-15">
        <div className=" flex items-center justify-center rounded-e-xl absolute top-4 left-[-10px] w-17.75 h-6 md:h-7 font-normal text-xs md:text-sm text-adad  bg-53  px-3 ">
            ID：{Number(formatUnits(data.id, 0)) + 1}
        </div>
        <div className="  border-b pb-5 border-4d mb-5">
            <div className=" flex items-center justify-between mb-6 px-2.5">
                <span className={leftClassName}>{t('contract.stakingAmount')}</span>
                <BalanceCom className={rightClassName} balance={data.initialAmount} loading={stakesLod} text={SYMBOL} />
            </div>
            <div className="flex items-center justify-between  px-2.5">
                <span className={leftClassName}>{t('contract.stakingPeriod')}</span>
                <PresentData className={rightClassName} value={unlockCycleDay} loading={false} text={t('contract.days')} />
            </div>
        </div>
        <div className=" flex items-center justify-between  mb-6  px-2.5">
            <span className={leftClassName}>{t('contract.currentHashrate')}</span>
            <Tooltip placement="topLeft" title={formatUnits(data.pool)} arrow>
                <div>
                    <BalanceCom className={rightClassName + " cursor-pointer"} balance={data.pool} loading={stakesLod} text={SYMBOL} />
                </div>
            </Tooltip>
        </div>
        <div className=" flex items-center justify-between  mb-6  px-2.5">
            <span className={leftClassName}>{t('contract.availableAmount')}</span>
            <Tooltip placement="topLeft" title={formatUnits(data.amount)} arrow>
                <div>
                    <BalanceCom className={rightClassName + " cursor-pointer"} balance={data.amount} loading={stakesLod} text={SYMBOL} />
                </div>
            </Tooltip>
        </div>
        <div className=" flex items-center justify-between  mb-6  px-2.5">
            <span className={leftClassName}>{t('contract.cumulativeEarnings')}</span>
            <Tooltip placement="topLeft" title={formatUnits(data.totalReward)} arrow>
                <div>
                    <BalanceCom className={rightClassName + " cursor-pointer"} balance={data.totalReward} loading={stakesLod} text={SYMBOL} />
                </div>
            </Tooltip>
        </div>
        <div className=" flex items-center justify-between  mb-6  px-2.5">
            <span className={leftClassName}>{t('contract.unclaimedEarnings')}</span>
            <Tooltip placement="topLeft" title={formatUnits(pendingStakeData)} arrow>
                <div>
                    <BalanceCom className={rightClassName + " cursor-pointer"} balance={pendingStakeData} loading={pendingStakeLod} text={SYMBOL} />
                </div>
            </Tooltip>
        </div>
        <div className=" flex items-center justify-between  mb-6  px-2.5">
            <span className={leftClassName}>{t('contract.stakingTime')}</span>
            <div className="flex ">
                <span className={rightClassName}>
                    {" "}
                    {dayjs
                        .unix(Number(data.startTime.toString()))
                        .format("YYYY.MM.DD HH:mm")}
                    -
                </span>
                <span className={rightClassName}>
                    {dayjs
                        .unix(Number(data.endTime.toString()))
                        .format("YYYY.MM.DD HH:mm")}
                </span>
            </div>
        </div>
        {data.amount ?
            <div className=" flex items-center justify-between gap-3">
                <ButtonPrimary text={t('contract.claimRewards')} disabled={stakesLod} className=" !rounded-md flex-1 h-11 md:h-12 text-sm md:text-base" loading={flowClaimLod} onClick={getFlowClaimFun} />
                {dayjs().unix() >= Number(data.endTime.toString()) &&
                    <ButtonDefault disabled={stakesLod} text={t('contract.redeem')}
                        className=" !rounded-md flex-1 h-11 md:h-12 text-sm md:text-base" loading={flowWithdrawLod} onClick={getFlowWithdrawFun} />
                }
            </div> :
            <ButtonDefault
                className="!rounded-md h-11 md:h-12 text-sm md:text-base" block text={t('contract.redeemed')} />
        }
    </div >
}
export default History